<template>
  <footer>
    <div class="container" :style='rootStyle'>
      <div class='items'>
        <a target='_blank' href="https://www.geekbang.org/aboutus">关于我们</a>
        <a target='_blank' href="https://www.geekbang.org/recruit">加入我们</a>
        <a target='_blank' href="https://www.geekbang.org/ivtw">关注我们</a>
        <a target='_blank' href="https://www.geekbang.org/partner">合作伙伴</a>
        <a target='_blank' href="https://service.geekbang.org">企业服务</a>
      </div>
      <div class='footcard'>
        <div class='card'>
          <i class="icon-font">&#xe604;</i>
          <p>业务合作<br />hezuo@geekbang.org<br />
          电话：010-64738140
          </p>
        </div>
        <div class='card'>
          <i class="icon-font">&#xe603;</i>
          <p>内容合作<br />content@geekbang.org</p>
        </div>
        <div class='card'>
          <i class="icon-font">&#xe601;</i>
          <p>反馈投诉<br />feedback@geekbang.org</p>
        </div>
        <div class='card'>
          <i class="icon-font">&#xe602;</i>
          <p>公司电话<br />010-64738142</p>
        </div>
      </div>
      <p class="copyright">&copy; 2018 Geekbang Technology Ltd. All rights reserved. 极客邦控股（北京）有限公司 | 京ICP备16027448号-3. </p>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    rootStyle: {
      type: Object,
      default: null
    }
  },
  created () {
    axios.get('/test')
  }
}
</script>


<style lang='scss' scoped>
@import "../../style/font/icon.css";

footer{
  box-sizing: border-box;
  background-color: #212326;
}
.container{
  margin: 0 auto;
  width: 96vw;
}
.items{
  box-sizing: border-box;
  padding-top: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #424242;
  display: flex;
  flex-wrap: wrap;
  a{
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 1rem;
    color: #fff;
    text-align: center;
    text-decoration: none;
    &:hover{
      color: #f66644;
    }
  }
}
.footcard{
  box-sizing: border-box;
  padding-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  .card{
    box-sizing: border-box;
    flex-basis:50%;
    // padding: 0 .75rem;
    text-align: center;
    i{
      display: none;
    }
    p{
      color: #888;
      font-size: .7rem;
      line-height: 1.2rem;
      padding-top: .6rem;
      padding-bottom: 1rem;
      padding-left: .75rem;
    }
  }
}
.copyright{
  font-size: .8rem;
  padding-bottom: 1rem;
  padding-left: .75rem;
  color: #888;
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
}

@media (min-width: 769px) {
  .container{
    width: 88vw;
  }
  .items{
    padding-top: 5rem;
    padding-bottom: 2.5rem;
    a{
      font-size: 1.1rem;
      padding-left: .75rem;
      text-align: left;
    }
  }
  .footcard{
    padding-top: 2.3rem;
    .card{
      display: flex;
      padding: 0 .75rem 1.5rem;
      align-items: center;
      i{
        display: block;
        color: #888;
        font-size: 3rem;
        margin-right: 1rem;
        line-height: 1.6;
      }
      p{
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.5;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .copyright{
    font-size: 1rem;
    padding-bottom: 1.4rem;
  }
}
@media (min-width: 1121px) {
  .container{
    min-width: 1202px;
  }
  .items{
    a{
      flex-grow: 0;
      flex-basis: 16.7%;
    }
  }
  .footcard{
    .card{
      flex-basis: 25%;
    }
  }
}
@media (min-width: 1584px) {
  .container{
    width: 60vw;
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?a349ee54